import styled from 'styled-components';
export const MetaNavigationList = styled.ul `
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style-type: none;

  @media ${({ theme }) => theme.device.medium} {
    flex-direction: row;
    flex-wrap: wrap;
  }

  @media ${({ theme }) => theme.device.large} {
    transform: translateX(0.5rem);
  }
`;
